<template>
  <div>
    <div v-if="showLogin">
      <new-accept-term-login @login-success="onLoginSuccess" :linkData="this.$route.params.data" />
    </div>
      <div v-else>
    <div class="header">
      <img
        class="header-logo"
        src="@/assets/totvs-rd-logo.svg"
        alt="RD Station Conversas logo"
      />
    </div>
    <div class="content-wrapper">
      <div class="column">
        <new-accept-term-form
          :loading="loading"
          @accepted="onAccepted"
          :companyName="companyUrlInformations.name"
          v-if="acceptanceStep === acceptanceSteps.ACCEPT"
        />
        <new-accept-term-retry
          :loading="loading"
          @accepted="onAccepted"
          v-if="acceptanceStep === acceptanceSteps.RETRY"
        />
        <new-accept-term-success
          :loading="loading"
          @accepted="onAccepted"
          v-if="acceptanceStep === acceptanceSteps.SUCCESS"
        />
      </div>
      <div class="column">
        <img
          class="acceptance-image"
          :src="acceptanceInformations[acceptanceStep].imageUrl"
          :alt="acceptanceInformations[acceptanceStep].altText"
        />
      </div>
    </div>
  </div>
  </div>
</template>
<script>
import axios from "axios";
import NewAcceptTermForm from "@/components/NewAcceptTermScreen/NewAcceptTermForm.vue";
import NewAcceptTermRetry from "@/components/NewAcceptTermScreen/NewAcceptTermRetry.vue";
import NewAcceptTermSuccess from "@/components/NewAcceptTermScreen/NewAcceptTermSuccess.vue";
import NewAcceptTermLogin from "@/components/NewAcceptTermScreen/NewAcceptTermLogin.vue"
import AcceptTerm from "@/assets/accept-term.svg";
import AcceptTermRetry from "@/assets/accept-term-retry.svg";
import AcceptTermSuccess from "@/assets/accept-term-success.svg";
import NewAcceptanceStatusMixin from "@/mixins/NewAcceptanceStatusMixin";
import { billingApiUrl, mainAppUrl } from "@/config/runtime-config";

export default {
  name: "NewAcceptTermScreen",

  mixins: [NewAcceptanceStatusMixin],

  components: {
    "new-accept-term-form": NewAcceptTermForm,
    "new-accept-term-retry": NewAcceptTermRetry,
    "new-accept-term-success": NewAcceptTermSuccess,
    "new-accept-term-login": NewAcceptTermLogin,
  },

  data() {
    return {
      acceptanceInformations: {
        accept: {
          imageUrl: AcceptTerm,
          altText: "Imagem ilustrativa de aceite de termos",
        },
        retry: {
          imageUrl: AcceptTermRetry,
          altText: "Imagem ilustrativa de erro durante o aceite",
        },
        success: {
          imageUrl: AcceptTermSuccess,
          altText: "Imagem ilustrativa de termo aceito com sucesso",
        },
      },
      acceptanceStep: "accept",
      loading: false,
      companyUrlInformations: {},
      showLogin: true
    };
  },

  methods: {
    onAccepted(result) {
      if (result === this.acceptanceSteps.SUCCESS) {
        return this.redirectToProduct();
      }
      this.acceptTerm();
    },

    async acceptTerm() {
      this.loading = true;
      let data = JSON.stringify({
        id_subscription: this.companyUrlInformations.id_subscription,
        email: this.companyUrlInformations.email,
        contract_url: "https://legal.rdstation.com/pt/rdc-services-agreement/",
        id_customer: this.companyUrlInformations.id_customer,
      });

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${billingApiUrl()}term`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      try {
        const result = await axios.request(config);
        if (result.status === 201) {
          localStorage.setItem("acceptTerm", true);
          this.acceptanceStep = this.acceptanceSteps.SUCCESS;
        } else {
          this.acceptanceStep = this.acceptanceSteps.RETRY;
        }
      } catch (error) {
        console.error("Error in acceptTerm:", error);
        this.acceptanceStep = this.acceptanceSteps.RETRY;
      }
      this.loading = false;
    },

    redirectToProduct() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        window.location.href = mainAppUrl();
      }, 5000);
    },

    getCompanyDataFromUrl() {
      try {
        const decodedString = atob(this.$route.params.data);
        this.companyUrlInformations = JSON.parse(decodedString);
      } catch (error) {
        console.error("Failed to parse company data from URL:", error);
        this.companyUrlInformations = {};
      }
    },

    verifyAcceptTerm() {
      this.acceptTermVerify = localStorage.getItem("acceptTerm");
      if (this.acceptTermVerify === "true") {
        this.acceptanceStep = this.acceptanceSteps.SUCCESS;
      }
    },

    onLoginSuccess() {
      this.showLogin = false;
    },
  },

  mounted() {
    this.getCompanyDataFromUrl();
    this.verifyAcceptTerm();
  },
};
</script>

<style scoped lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Red+Hat+Display:wght@400;600&display=swap");

:root {
  font-family: "Red Hat Display", sans-serif;
  font-size: 16px;
}

.header {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  padding: 1rem 0;
  box-shadow: 0px 4px 12px 0px rgba(33, 36, 41, 0.14);

  .header-logo {
    height: 32px;
  }
}

.content-wrapper {
  display: flex;
  gap: 0 1rem;
  justify-content: space-between;
  min-height: calc(100vh - 72px);

  .column {
    flex: 1;
    align-content: center;

    .acceptance-image {
      width: 100%;
      height: auto;
      padding-right: 72px;
    }
  }
}

@media (max-width: 500px) {
  .content-wrapper {
    padding-top: 16px;
    gap: 16px;
    justify-content: start;
    flex-direction: column-reverse;

    .column {
      flex: none;
      img.acceptance-image {
        padding: 0 32px;
      }

      .acceptance-form {
        padding: 0 32px 16px 32px;
      }
    }
  }
}
</style>
